// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentVerifySurveyEntryResultModelResponse {
    static getAttributeTypeMap() {
        return EnrollmentVerifySurveyEntryResultModelResponse.attributeTypeMap;
    }
}
EnrollmentVerifySurveyEntryResultModelResponse.discriminator = undefined;
EnrollmentVerifySurveyEntryResultModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentVerifySurveyEntryResultModel"
    }
];
//# sourceMappingURL=enrollmentVerifySurveyEntryResultModelResponse.js.map